module.exports = __webpack_public_path__ + "static/gift-card-77cf6196a4ca3eeb49fdb8eb37bb6080.jpg";